// 当前股票持仓短轮询
import { TIMER_EXPRESSION } from 'const/common'
import { mapGetters } from 'vuex'

export default {
  name: 'stockHoldingPollMixin',
  computed: {
    ...mapGetters(['hkMarketOpen', 'usMarketOpen', 'usHourTrading']),
    isNeedPolling() {
      return this.usMarketOpen || this.usHourTrading || this.hkMarketOpen
    }
  },
  data() {
    return {
      timer: null
    }
  },
  mounted() {
    this.timer = this.$cron(TIMER_EXPRESSION.HOLDING_ORDERS).interval(
      'POSITION_HOLDING_POLL',
      () => {
        this.getStockHoldingsAndOrders()
      }
    )
    if (!this.isNeedPolling) {
      this.timer.pause()
    }
  },
  watch: {
    isNeedPolling(newValue) {
      if (!this.timer) {
        return
      }
      newValue ? this.timer.resume() : this.timer.pause()
    }
  },
  beforeDestroy() {
    if (this.timer) {
      this.timer.clear()
    }
  }
}
